export { SectionHeading } from "./SectionHeading"
export { BGImage } from "./BgImage"
export { FooterBgImg } from "./FooterBgImg"
export { ServiceImg } from './ServiceImg'